
import {get} from 'lodash-es'
import {addDays, subDays, differenceInDays} from 'date-fns/esm'

import {dateToObject, dateToString, isEqualOrBefore} from 'helpers/date'

//

const mixin = {
  state() {
    return {
      timeStepMinutes: null,
      daysPerPeriod:   null,
      periodsCount:    null,
      originDate:      null,
      today:           null,
    }
  },

  getters: {
    makeNearestPeriodBegin: state => (date, offsetPeriod) => {
      const date_ = dateToObject(date)
      const origin = dateToObject(state.originDate)
      const diff = Math.floor(differenceInDays(date_, origin) / state.daysPerPeriod) + offsetPeriod
      return addDays(origin, diff * state.daysPerPeriod)
    },

    latestPeriod: (state, getters) => {
      const latest = getters.makeNearestPeriodBegin(state.today, 1)
      return {
        begin: dateToString(latest),
        end: dateToString(addDays(latest, state.daysPerPeriod - 1)),
      }
    },

    periods: (state, getters) => {
      const latest = getters.makeNearestPeriodBegin(state.today, 1)
      let date = subDays(latest, state.daysPerPeriod * state.periodsCount)
      const periods = []
      while(isEqualOrBefore(date, latest)) {
        periods.push({
          begin: dateToString(date),
          end: dateToString(addDays(date, state.daysPerPeriod - 1)),
        })
        date = addDays(date, state.daysPerPeriod)
      }
      return periods
    },

    getNearestPeriod: (state, getters) => date => {
      const nearest = getters.makeNearestPeriodBegin(date, 0)
      return {
        begin: dateToString(nearest),
        end: dateToString(addDays(nearest, state.daysPerPeriod - 1)),
      }
    },
  },

  mutations: {
    timeStepMinutes(state, value) {state.timeStepMinutes = value},
    daysPerPeriod  (state, value) {state.daysPerPeriod   = value},
    periodsCount   (state, value) {state.periodsCount    = value},
    originDate     (state, value) {state.originDate      = value},
    today          (state, value) {state.today           = value},
  },

  actions: {
    async updateDate({commit}, date) {
      commit('timeStepMinutes', get(date, 'timeStepMinutes'))
      commit('daysPerPeriod',   get(date, 'daysPerPeriod'))
      commit('periodsCount',    get(date, 'periodsCount'))
      commit('originDate',      get(date, 'originDate'))
      commit('today',           dateToString(new Date()))
    },
  },
}

export default mixin
